import { render, staticRenderFns } from "./BidAdjustments.vue?vue&type=template&id=08b3b29f"
import script from "./BidAdjustments.vue?vue&type=script&lang=js"
export * from "./BidAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports